import { BiInjection, BiTestTube } from "react-icons/bi";
import { CgFileDocument } from "react-icons/cg";
import { FaRegCalendarAlt, FaRegChartBar, FaStethoscope } from "react-icons/fa";
import {} from "react-icons/pi";

import { HiOutlineDocumentText } from "react-icons/hi";
import { LuBiohazard, LuFileBarChart2 } from "react-icons/lu";
import {
  MdOutlineCalendarMonth,
  MdOutlineMasks,
  MdOutlineNightlight,
  MdOutlinePersonalInjury,
} from "react-icons/md";
import {
  PiEyedropperSampleBold,
  PiPillBold,
  PiVirusBold,
  PiWarningBold,
} from "react-icons/pi";
import {
  RiGraduationCapLine,
  RiMedicineBottleLine,
  RiUser2Line,
} from "react-icons/ri";
import { TbBeach, TbBed, TbFileUpload, TbNotes } from "react-icons/tb";
import { ButtonColor } from "../components/buttons";
import {
  CardItemType,
  EvolutionType,
  RhEventType,
  TableName,
} from "./allTypes";

export const rhEventTypes: Record<
  RhEventType,
  {
    id: RhEventType;
    name: string;
    color: ButtonColor;
    icon: any;
  }
> = {
  affectation: {
    id: "affectation",
    name: "Affectation",
    color: "orange",
    icon: <FaRegCalendarAlt size={18} />,
  },
  shift: {
    id: "shift",
    name: "Garde",
    color: "blue",
    icon: <MdOutlineNightlight size={18} />,
  },
  holiday: {
    id: "holiday",
    name: "Congé",
    color: "green",
    icon: <TbBeach size={18} />,
  },
  teaching: {
    id: "teaching",
    name: "Enseignement",
    color: "purple",
    icon: <RiGraduationCapLine size={18} />,
  },
};

export const evolutionItemTypes: Record<
  EvolutionType,
  {
    id: EvolutionType;
    name: string;
    table: TableName;
  }
> = {
  billet: {
    id: "billet",
    name: "Billet de salle",
    table: "billets",
  },
  initialExamination: {
    id: "initialExamination",
    name: "Examen clinique initial",
    table: "initialExaminations",
  },
  admission: {
    id: "admission",
    name: "Observation d'admission",
    table: "admissions",
  },
  evolution: {
    id: "evolution",
    name: "Mot d'évolution",
    table: "evolutions",
  },

  anesthesiologyConsultation: {
    id: "anesthesiologyConsultation",
    name: "Pré-anesthésie",
    table: "anesthesiologyConsultations",
  },
  anesthesiologySummary: {
    id: "anesthesiologySummary",
    name: "Pré-anesthésie",
    table: "anesthesiologySummaries",
  },
  complication: {
    id: "complication",
    name: "Complication",
    table: "complications",
  },

  shift: {
    id: "shift",
    name: "Mot de la garde",
    table: "shifts",
  },
  intervention: {
    id: "intervention",
    name: "Intervention",
    table: "interventions",
  },
  avis: {
    id: "avis",
    name: "Avis",
    table: "avis",
  },
  ventilation: {
    id: "ventilation",
    name: "Ventilation",
    table: "ventilations",
  },

  transferDemand: {
    id: "transferDemand",
    name: "Transfert",
    table: "transferDemands",
  },
  discharge: {
    id: "discharge",
    name: "Sortie",
    table: "discharges",
  },
  temporaryLeave: {
    id: "temporaryLeave",
    name: "Congé",
    table: "temporaryLeaves",
  },
  toxicity: {
    id: "toxicity",
    name: "Toxicité",
    table: "toxicities",
  },
} as const;

export const allItemTypes: Record<
  CardItemType,
  {
    id: CardItemType;
    name: string;
    icon?: any;
    color: string;
    secondaryColor: string;
  }
> = {
  simple: {
    id: "simple",
    name: "Simple",
    icon: null,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  gray: {
    id: "gray",
    name: "Gris",
    icon: null,
    color: "rgba(0, 0, 0,0.8)",
    secondaryColor: "rgba(0, 0, 0,0.1)",
  },
  red: {
    id: "red",
    name: "Rouge",
    icon: null,
    color: "rgba(255, 0, 0,1)",
    secondaryColor: "rgba(255, 0, 0,0.1)",
  },
  green: {
    id: "green",
    name: "Vert",
    icon: null,
    color: "rgba(2, 194, 75, 1)",
    secondaryColor: "rgba(2, 194, 75,0.12)",
  },
  blue: {
    id: "blue",
    name: "Bleu",
    icon: null,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  yellow: {
    id: "yellow",
    name: "Jaune",
    icon: null,
    color: "rgba(255, 255, 0,1)",
    secondaryColor: "rgba(255, 255, 0,0.1)",
  },
  orange: {
    id: "orange",
    name: "Orange",
    icon: null,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  purple: {
    id: "purple",
    name: "Violet",
    icon: null,
    color: "rgba(144, 0, 255,1)",
    secondaryColor: "rgba(144, 0, 255,0.1)",
  },
  pink: {
    id: "pink",
    name: "Rose",
    icon: null,
    color: "rgba(255, 77, 115,1)",
    secondaryColor: "rgba(255, 77, 115,0.1)",
  },

  white: {
    id: "white",
    name: "Blanc",
    icon: null,
    color: "rgba(255, 255, 255,1)",
    secondaryColor: "rgba(255, 255, 255,0.1)",
  },

  consultation: {
    id: "consultation",
    name: "Consultation",
    icon: <FaStethoscope />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 136, 255,0.1)",
  },

  evolution: {
    id: "evolution",
    name: "Mot d'évolution",
    icon: <TbNotes />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  transferDemand: {
    id: "transferDemand",
    name: "Transfert",
    icon: <RiUser2Line />,
    color: "rgba(255, 255, 0,1)",
    secondaryColor: "rgba(255, 255, 0,0.1)",
  },
  temporaryLeave: {
    id: "temporaryLeave",
    name: "Congé",
    icon: <TbNotes />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  discharge: {
    id: "discharge",
    name: "Sortie",
    icon: <TbNotes />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  shift: {
    id: "shift",
    name: "Mot de la garde",
    icon: <TbNotes />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  anesthesiologyConsultation: {
    id: "anesthesiologyConsultation",
    name: "Pré-anesthésie",
    icon: <RiMedicineBottleLine />,
    color: "rgba(255, 255, 0,1)",
    secondaryColor: "rgba(255, 255, 0,0.1)",
  },
  anesthesiologySummary: {
    id: "anesthesiologySummary",
    name: "Résumé Anesthésie",
    icon: <RiMedicineBottleLine />,
    color: "rgba(255, 255, 0,1)",
    secondaryColor: "rgba(255, 255, 0,0.1)",
  },
  complication: {
    id: "complication",
    name: "Complication",
    icon: <RiMedicineBottleLine />,
    color: "rgba(255, 255, 0,1)",
    secondaryColor: "rgba(255, 255, 0,0.1)",
  },
  story: {
    id: "story",
    name: "Histoire de la maladie",
    icon: <FaStethoscope />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },

  intervention: {
    id: "intervention",
    name: "Intervention",
    icon: <MdOutlinePersonalInjury />,
    color: "rgba(18, 129, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  ventilation: {
    id: "ventilation",
    name: "Ventilation",
    icon: <MdOutlineMasks />,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },

  initialExamination: {
    id: "initialExamination",
    name: "Examen clinique initial",
    icon: <HiOutlineDocumentText />,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },

  admission: {
    id: "admission",
    name: "Observation d'admission",
    icon: <HiOutlineDocumentText />,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  billet: {
    id: "billet",
    name: "Billet de salle",
    icon: <HiOutlineDocumentText />,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },
  avis: {
    id: "avis",
    name: "Avis",
    icon: <HiOutlineDocumentText />,
    color: "rgba(0, 85, 255,1)",
    secondaryColor: "rgba(0, 85, 255,0.1)",
  },

  consigne: {
    id: "consigne",
    name: "Consigne",
    icon: <FaStethoscope />,
    color: "rgba(144, 0, 255,1)",
    secondaryColor: "rgba(144, 0, 255,0.1)",
  },
  mesure: {
    id: "mesure",
    name: "Mesure",
    icon: <FaRegChartBar />,
    // color: "rgba(255, 77, 115,1)",
    // secondaryColor: "rgba(255, 77, 115,0.1)",
    color: "rgba(235, 34, 23,1)",
    secondaryColor: "rgba(235, 34, 23,0.1)",
  },
  score: {
    id: "score",
    name: "Score",
    icon: <LuFileBarChart2 />,
    color: "rgba(235, 34, 23,1)",
    secondaryColor: "rgba(235, 34, 23,0.1)",
  },
  upload: {
    id: "upload",
    name: "Fichier",
    icon: <TbFileUpload />,
    color: "rgba(255, 77, 115,1)",
    secondaryColor: "rgba(255, 77, 115,0.1)",
  },

  radiotherapy: {
    id: "radiotherapy",
    name: "Radiothérapie",
    icon: <LuBiohazard />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  surgery: {
    id: "surgery",
    name: "Chirurgie",
    icon: <MdOutlinePersonalInjury />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  metastasis: {
    id: "metastasis",
    name: "Métastase",
    icon: <PiVirusBold />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  toxicity: {
    id: "toxicity",
    name: "Toxicité",
    icon: <PiWarningBold />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  cure: {
    id: "cure",
    name: "Cure",
    icon: <BiInjection />,
    color: "rgba(144, 0, 255,1)",
    secondaryColor: "rgba(144, 0, 255,0.1)",
  },

  exam: {
    id: "exam",
    name: "Examen",
    icon: <BiTestTube />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  examDemand: {
    id: "examDemand",
    name: "Demande d'examen",
    icon: <BiTestTube />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },

  examStep: {
    id: "examStep",
    name: "Étape d'examen",
    icon: <BiTestTube />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
  diagnostic: {
    id: "diagnostic",
    name: "Diagnostic",
    icon: <FaStethoscope />,
    color: "rgba(20, 150, 57,1)",
    secondaryColor: "rgba(20, 150, 57,0.1)",
  },
  appointment: {
    id: "appointment",
    name: "Rendez-vous",
    icon: <MdOutlineCalendarMonth />,
    color: "rgba(0, 136, 255,1)",
    secondaryColor: "rgba(0, 136, 255,0.1)",
  },

  document: {
    id: "document",
    name: "Document",
    icon: <CgFileDocument />,
    color: "rgba(2, 194, 75, 0.9)",
    secondaryColor: "rgba(2, 194, 75,0.1)",
  },
  ordonnance: {
    id: "ordonnance",
    name: "Ordonnance",
    icon: <PiPillBold />,
    color: "rgba(144, 0, 255,1)",
    secondaryColor: "rgba(144, 0, 255,0.1)",
  },
  hospitalisation: {
    id: "hospitalisation",
    name: "Hospitalisation",
    icon: <TbBed />,
    color: "rgba(0, 136, 255,1)",
    secondaryColor: "rgba(0, 136, 255,0.1)",
  },

  sample: {
    id: "sample",
    name: "Échantillon",
    icon: <PiEyedropperSampleBold />,
    color: "rgba(255, 124, 2,1)",
    secondaryColor: "rgba(255, 124, 2,0.1)",
  },
};

export const aiImageCompletion = `
  <div id="ai-content">
  <br><br>
    <img class="ai-loading" src="./images/loading-blue.gif" style="height:30px; width:30px;" />
    <br><br>
  
  <h2 class="ai-fade" style="animation-delay: 2000ms" >HÉMATOLOGIE</h2>
  <table class="ai-fade" style="animation-delay: 2000ms" >
    <tr>
      <th class="ai-fade" style="animation-delay: 2100ms" >Formule Numération Sanguine</th>
      <th class="ai-fade" style="animation-delay: 2200ms" >Résultats</th>
      <th class="ai-fade" style="animation-delay: 2300ms" >Unités</th>
      <th class="ai-fade" style="animation-delay: 2400ms" >Normes</th>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 2500ms" >Globules Rouges</td>
      <td class="ai-fade" style="animation-delay: 2600ms" >5.32</td>
      <td class="ai-fade" style="animation-delay:2700ms" >10<sup>6</sup>/μL</td>
      <td class="ai-fade" style="animation-delay: 2800ms" >4.20 - 5.70</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 2900ms" >Hémoglobine</td>
      <td class="ai-fade" style="animation-delay: 3000ms" >13.9</td>
      <td class="ai-fade" style="animation-delay: 3100ms" >g/dL</td>
      <td class="ai-fade" style="animation-delay: 3200ms" >12 - 15.5</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 3300ms" >Hématocrite</td>
      <td class="ai-fade" style="animation-delay: 3400ms" >43.1</td>
      <td class="ai-fade" style="animation-delay: 3500ms" >%</td>
      <td class="ai-fade" style="animation-delay: 3600ms" >40 - 52</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 3700ms" >VGM</td>
      <td class="ai-fade" style="animation-delay: 3800ms" >81</td>
      <td class="ai-fade" style="animation-delay: 3900ms" >fL</td>
      <td class="ai-fade" style="animation-delay: 4000ms" >80 - 95</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 4100ms" >TCMH</td>
      <td class="ai-fade" style="animation-delay: 4300ms" >26.1</td>
      <td class="ai-fade" style="animation-delay: 4400ms" >pg</td>
      <td class="ai-fade" style="animation-delay: 5000ms" >28 - 32</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 5100ms" >CCMH</td>
      <td class="ai-fade" style="animation-delay: 5200ms" >32.3</td>
      <td class="ai-fade" style="animation-delay: 5300ms" >g/dL</td>
      <td class="ai-fade" style="animation-delay: 5400ms" >30 - 35</td>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 5500ms" >Globules Blancs</td>
      <td class="ai-fade" style="animation-delay: 5600ms" >5.4</td>
      <td class="ai-fade" style="animation-delay: 5700ms" >10<sup>3</sup>/μL</td>
      <td class="ai-fade" style="animation-delay: 5900ms" >4 - 10</td>
    </tr>
    <!-- Insérez ici les autres lignes pour les Neutrophiles, Éosinophiles, Basophiles, Lymphocytes, Monocytes et Plaquettes -->
  </table>
  
  <h2 class="ai-fade" style="animation-delay: 6000ms;  margin-top:30px;" >HORMONOLOGIE</h2>
  <table class="ai-fade" style="animation-delay: 6000ms" >
    <tr>
      <th class="ai-fade" style="animation-delay: 6100ms" >Test</th>
      <th class="ai-fade" style="animation-delay: 6200ms" >Résultats</th>
      <th class="ai-fade" style="animation-delay: 6300ms" >Unités</th>
      <th class="ai-fade" style="animation-delay: 6400ms" >Normes</th>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 6500ms" >TSH Ultra sensible</td>
      <td class="ai-fade" style="animation-delay: 6600ms" >1.11</td>
      <td class="ai-fade" style="animation-delay: 6700ms" >μUI/ml</td>
      <td class="ai-fade" style="animation-delay: 6800ms" >0.27 - 4.20</td>
    </tr>
  </table>
  
  <h2 class="ai-fade" style="animation-delay: 6900ms; margin-top:30px;" >SÉROLOGIE INFLAMMATOIRE</h2>
  <table class="ai-fade" style="animation-delay: 7000ms" >
    <tr>
      <th class="ai-fade" style="animation-delay: 7000ms" >Test</th>
      <th class="ai-fade" style="animation-delay: 7100ms" >Résultats</th>
      <th class="ai-fade" style="animation-delay: 7200ms" >Unités</th>
      <th class="ai-fade" style="animation-delay: 7300ms" >Normes</th>
    </tr>
    <tr>
      <td class="ai-fade" style="animation-delay: 7400ms" >CRP</td>
      <td class="ai-fade" style="animation-delay: 7500ms" >< 6</td>
      <td class="ai-fade" style="animation-delay: 7600ms" >mg/L</td>
      <td class="ai-fade" style="animation-delay: 7900ms" >< 6</td>
    </tr>
  </table>
  </div>
  
  `;

export const compteRendu1 = `
  <div id="ai-content">
  <br><br>
    <img class="ai-loading" src="./images/loading-blue.gif" style="height:30px; width:30px;" />
    <br><br>
    <strong style="animation-delay:2000ms; " class="ai-fade">Motif d'hospitalisation:</strong><br style="animation-delay:2100ms; " class="ai-fade">
    <strong style="animation-delay:2200ms; " class="ai-fade"><strong style="animation-delay:2300ms; " class="ai-fade">Décompensation cardiaque droite à&nbsp;</strong></strong><span style="animation-delay:2400ms; " class="ai-fade"><font style="animation-delay:2500ms; " class="ai-fade"><b style="animation-delay:2600ms; " class="ai-fade">prédominance droite sur Cardiopathie dilatée&nbsp;</b></font></span><strong style="animation-delay:2700ms; " class="ai-fade"><div style="animation-delay:2800ms; " class="ai-fade"></div></strong><span ;="" style="animation-delay:2900ms; " class="ai-fade">&nbsp;le patient&nbsp; Biloubar Mahieddine âgé de 54 ans&nbsp; ,&nbsp;&nbsp;</span><span ;="" style="animation-delay:3000ms; " class="ai-fade">autonome&nbsp;, assuré , demeurant à Mniaa , admis à notre niveau pour la PEC d'une décompensation cardiaque à prédominance droite sur Cardiopathie dilatée&nbsp;</span><br style="animation-delay:3100ms; " class="ai-fade"><br style="animation-delay:3200ms; " class="ai-fade">
  
    <span class="bold ai-fade" style="animation-delay:3300ms; ">FDR / Antécédents: </span>
    <div style="animation-delay:3400ms; " class="ai-fade">  <div style="animation-delay:3500ms; " class="ai-fade">-  AGE  </div><div style="animation-delay:3600ms; " class="ai-fade">- Tabagisme    sevré  En 2014 </div><div style="animation-delay:3700ms; " class="ai-fade">- APPENDICECTOMIE en 1981</div><div style="animation-delay:3800ms; " class="ai-fade">- Cardiomyopathie dilatée (CMD) </div></div>
    <br style="animation-delay:3900ms; " class="ai-fade"><div class="bold ai-fade" style="animation-delay:4000ms; ">Histoire de la maladie: </div>
    <div style="animation-delay:4100ms; " class="ai-fade"><br style="animation-delay:4200ms; " class="ai-fade">Patient connu pour CMD depuis 2014 mal suivi 
  Il consulte ce jour à notre niveau pour décompensation cardiaque droite , d'où son admission 
  </div>
    <br style="animation-delay:4300ms; " class="ai-fade"><div style="animation-delay:4400ms; " class="ai-fade"><div style="animation-delay:4500ms; " class="ai-fade"><div style="animation-delay:4600ms; " class="ai-fade"><br style="animation-delay:4700ms; " class="ai-fade"><div style="animation-delay:4800ms; " class="ai-fade"><b style="animation-delay:4900ms; " class="ai-fade"><br style="animation-delay:5000ms; " class="ai-fade"><div style="animation-delay:5100ms; " class="ai-fade"><b style="animation-delay:5200ms; " class="ai-fade"><span style="animation-delay:5300ms; " ;="" class="ai-fade">à&nbsp; l'admission :</span></b></div></b>
  <span style="animation-delay:5400ms; " ;="" class="ai-fade">Patient conscient coopérant ,</span><span style="animation-delay:5500ms; " ;="" class="ai-fade">EG conservé </span><br style="animation-delay:5600ms; " class="ai-fade"><br style="animation-delay:5700ms; " class="ai-fade"><span style="animation-delay:5800ms; " ;="" class="ai-fade">PA 100/80 mmhg&nbsp;&nbsp;</span><span style="animation-delay:5900ms; " ;="" class="ai-fade">FC 80 bpm&nbsp;&nbsp;</span><span style="animation-delay:6000ms; " ;="" class="ai-fade">Sat 98%&nbsp;en AA </span><br style="animation-delay:6100ms; " class="ai-fade">
  <span style="animation-delay:6200ms; " ;="" class="ai-fade">Extrémités chaudes et&nbsp;</span><span style="animation-delay:6300ms; " ;="" class="ai-fade">Diurèse conservée </span>
  <br style="animation-delay:6400ms; " class="ai-fade"><br style="animation-delay:6500ms; " class="ai-fade"><span style="animation-delay:6600ms; " ;="" class="ai-fade">SF: asthénie&nbsp;</span></div><div style="animation-delay:6700ms; " class="ai-fade"><span style="animation-delay:6800ms; " class="ai-fade">Pas d'angor, pas de dyspnée ni d'orthopnée&nbsp;<br style="animation-delay:6900ms; " class="ai-fade"></span>
  <span style="animation-delay:7000ms; " ;="" class="ai-fade">SP :</span><br style="animation-delay:7100ms; " class="ai-fade">
  <span style="animation-delay:7200ms; " ;="" class="ai-fade"> BDC audibles sans souffle ni BSA </span><br style="animation-delay:7300ms; " class="ai-fade"><span style="animation-delay:7400ms; " class="ai-fade">Râles crépitants aux bases pulmonaires&nbsp;</span></div><div style="animation-delay:7500ms; " class="ai-fade"><span style="animation-delay:7600ms; " class="ai-fade">Ascite de grande abondance&nbsp;</span></div><div style="animation-delay:7700ms; " class="ai-fade"><span style="animation-delay:7800ms; " class="ai-fade">OMI jusqu'aux genoux&nbsp;</span></div><div style="animation-delay:7900ms; " class="ai-fade"><span style="animation-delay:8000ms; " class="ai-fade">HPM, TJ&nbsp;<br style="animation-delay:8100ms; " class="ai-fade"></span>
  <span style="animation-delay:8200ms; " ;="" class="ai-fade">Absence de signes de TVP&nbsp;</span><br style="animation-delay:8300ms; " class="ai-fade">
  <span style="animation-delay:8400ms; " ;="" class="ai-fade">Pouls présents symétriques&nbsp;</span><br style="animation-delay:8500ms; " class="ai-fade">
  <span style="animation-delay:8600ms; " ;="" class="ai-fade">Le reste de l'examen clinique est sans particularité&nbsp;</span>
  <br style="animation-delay:8700ms; " class="ai-fade"><br style="animation-delay:8800ms; " class="ai-fade"><span style="animation-delay:8900ms; " ;="" class="ai-fade">ECG: RSR à 85 bpm, BBGc , ESVs monomorphes , retard droit , couplage long&nbsp;</span><br style="animation-delay:9000ms; " class="ai-fade"><br style="animation-delay:9100ms; " class="ai-fade"><span style="animation-delay:9200ms; " ;="" class="ai-fade">Biologie d'admission: </span><br style="animation-delay:9300ms; " class="ai-fade">
  <span style="animation-delay:9400ms; " ;="" class="ai-fade">GB 6280/mm3&nbsp; &nbsp;</span><span style="animation-delay:9500ms; " ;="" class="ai-fade">HB 11.1g/dl&nbsp;&nbsp;</span><span style="animation-delay:9600ms; " ;="" class="ai-fade">Plq 182 000/mm3</span><br style="animation-delay:9700ms; " class="ai-fade">
  <span style="animation-delay:9800ms; " ;="" class="ai-fade">Urée 0.71g/l&nbsp;&nbsp;</span><span style="animation-delay:9900ms; " ;="" class="ai-fade">Créat 11.7 mg/l&nbsp; &nbsp;clairance de 69 ml/min( MDRD)</span><br style="animation-delay:10000ms; " class="ai-fade">
  <span style="animation-delay:10100ms; " ;="" class="ai-fade">Na 133meq/l&nbsp;&nbsp;</span><span style="animation-delay:10200ms; " ;="" class="ai-fade">K 3.4meq/l</span></div><div style="animation-delay:10300ms; " class="ai-fade"><span style="animation-delay:10400ms; " ;="" class="ai-fade">Glu 0.96g/l</span></div><div style="animation-delay:10500ms; " class="ai-fade"><span style="animation-delay:10600ms; " class="ai-fade">TP 60%&nbsp; INR 1.4&nbsp; TCK 31</span></div><div style="animation-delay:10700ms; " class="ai-fade"><span style="animation-delay:10800ms; " class="ai-fade">BNP 1070</span><br style="animation-delay:10900ms; " class="ai-fade"><br style="animation-delay:11000ms; " class="ai-fade"><span style="animation-delay:11100ms; " ;="" class="ai-fade">ETT&nbsp; :</span><br style="animation-delay:11200ms; " class="ai-fade"></div><div style="animation-delay:11300ms; " class="ai-fade"><span style="animation-delay:11400ms; " ;="" class="ai-fade"><div style="animation-delay:11500ms; " class="ai-fade">CARDIOMYOPATHIE DILATÉE AU STADE DE DILATATION TETRA CAVITAIRE&nbsp;</div><div style="animation-delay:11600ms; " class="ai-fade">VG TRÈS DILATE, HYPOKINÉSIE GLOBALE AVEC UNE DYSKINESIE SEPTALE</div><div style="animation-delay:11700ms; " class="ai-fade">IM GRADE II</div><div style="animation-delay:11800ms; " class="ai-fade">FEVG TRÈS ALTÉRÉE A 20 -25 %&nbsp;</div><div style="animation-delay:11900ms; " class="ai-fade">CAVITES DROITES DLATEES</div><div style="animation-delay:12000ms; " class="ai-fade">IT MASSIVE</div><div style="animation-delay:12100ms; " class="ai-fade">VEINE CAVE INFÉRIEURE DILATÉE NON COMPLIANTE&nbsp;</div><div style="animation-delay:12200ms; " class="ai-fade">ÉPANCHEMENT PÉRICARDIQUE DE MOYENNE ABONDANCE</div><div style="animation-delay:12300ms; " class="ai-fade"><br style="animation-delay:12400ms; " class="ai-fade"></div></span></div><div style="animation-delay:12500ms; " class="ai-fade"><span style="animation-delay:12600ms; " ;="" class="ai-fade"><b style="animation-delay:12700ms; " class="ai-fade">Echo-Doppler&nbsp; hépatique</b> le 06/06/23</span></div><div style="animation-delay:12800ms; " class="ai-fade"><span style="animation-delay:12900ms; " ;="" class="ai-fade">Foie cardiaque,&nbsp; en décompensation ascitique , épanchement intra péritonéal libre de grande abondance&nbsp;</span></div><div style="animation-delay:13000ms; " class="ai-fade"><span style="animation-delay:13100ms; " ;="" class="ai-fade">Absence de thrombose porte&nbsp;</span></div><div style="animation-delay:13200ms; " class="ai-fade"><span style="animation-delay:13300ms; " ;="" class="ai-fade">Absence de signes d HTP</span></div><div style="animation-delay:13400ms; " class="ai-fade"><span style="animation-delay:13500ms; " class="ai-fade"><br style="animation-delay:13600ms; " class="ai-fade"></span></div><div style="animation-delay:13700ms; " class="ai-fade"><b style="animation-delay:13800ms; " class="ai-fade"><span style="animation-delay:13900ms; " ;="" class="ai-fade"></span><span style="animation-delay:14000ms; " class="ai-fade">Coronarographie en 04/2020&nbsp;</span></b></div><div style="animation-delay:14100ms; " class="ai-fade"><span style="animation-delay:14200ms; " class="ai-fade"><b style="animation-delay:14300ms; " class="ai-fade">Absence de sténose significative&nbsp;</b></span></div><div style="animation-delay:14400ms; " class="ai-fade"></div><br style="animation-delay:14500ms; " class="ai-fade"><div style="animation-delay:14600ms; " class="ai-fade"><span style="animation-delay:14700ms; " ;="" class="ai-fade"><br style="animation-delay:14800ms; " class="ai-fade"></span></div><div style="animation-delay:14900ms; " class="ai-fade"><span style="animation-delay:15000ms; " ;="" class="ai-fade">NB&nbsp;</span></div><div style="animation-delay:15100ms; " class="ai-fade"><span style="animation-delay:15200ms; " ;="" class="ai-fade">Ponction d'scite exploratrice faite la semaine passée au service de gastro-entérologie BM</span></div><div style="animation-delay:15300ms; " class="ai-fade"><span style="animation-delay:15400ms; " ;="" class="ai-fade">Résultats prévus pour demain&nbsp;</span></div><div style="animation-delay:15500ms; " class="ai-fade"><span style="animation-delay:15600ms; " ;="" class="ai-fade"><br style="animation-delay:15700ms; " class="ai-fade"></span></div></div></div></div><div style="animation-delay:15800ms; " class="ai-fade"><br style="animation-delay:15900ms; " class="ai-fade"></div><div class="bold ai-fade" style="animation-delay:16000ms; ">Traitement intra-hospitalier: </div>
    <div style="animation-delay:16100ms; " class="ai-fade"></div>
    Aldactione 75mg 1/2cp&nbsp; Triatec 2.5mg&nbsp; Bisoprolol 2.5mg&nbsp;
    </div>
  `;

export const bmlabexams = [
  {
    Num: 6998,
    "Nom du param": "Ionogramme urinaire",
  },
];

export const barcode1 = `
<svg class="" width="123px" height="40px" x="0px" y="0px" viewBox="0 0 123 40" xmlns="http://www.w3.org/2000/svg" version="1.1" style="transform: translate(0,0)"><rect x="0" y="0" width="123" height="40" style="fill:#ffffff;"></rect><g transform="translate(0, 0)" style="fill:#000000;"><rect x="0" y="0" width="2" height="40"></rect><rect x="3" y="0" width="1" height="40"></rect><rect x="6" y="0" width="1" height="40"></rect><rect x="11" y="0" width="1" height="40"></rect><rect x="13" y="0" width="3" height="40"></rect><rect x="17" y="0" width="2" height="40"></rect><rect x="22" y="0" width="2" height="40"></rect><rect x="25" y="0" width="3" height="40"></rect><rect x="31" y="0" width="1" height="40"></rect><rect x="33" y="0" width="1" height="40"></rect><rect x="38" y="0" width="1" height="40"></rect><rect x="40" y="0" width="2" height="40"></rect><rect x="44" y="0" width="4" height="40"></rect><rect x="50" y="0" width="1" height="40"></rect><rect x="53" y="0" width="1" height="40"></rect><rect x="55" y="0" width="1" height="40"></rect><rect x="57" y="0" width="3" height="40"></rect><rect x="63" y="0" width="2" height="40"></rect><rect x="66" y="0" width="2" height="40"></rect><rect x="69" y="0" width="3" height="40"></rect><rect x="75" y="0" width="1" height="40"></rect><rect x="77" y="0" width="3" height="40"></rect><rect x="81" y="0" width="2" height="40"></rect><rect x="84" y="0" width="1" height="40"></rect><rect x="88" y="0" width="2" height="40"></rect><rect x="92" y="0" width="1" height="40"></rect><rect x="95" y="0" width="3" height="40"></rect><rect x="99" y="0" width="2" height="40"></rect><rect x="102" y="0" width="3" height="40"></rect><rect x="106" y="0" width="3" height="40"></rect><rect x="110" y="0" width="2" height="40"></rect><rect x="115" y="0" width="3" height="40"></rect><rect x="119" y="0" width="1" height="40"></rect><rect x="121" y="0" width="2" height="40"></rect></g></svg>
`;
